module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrapper"
  }, [_c('div', {
    staticClass: "logo"
  }), _c('div', {
    staticClass: "login-bg"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Referrals Query System")]), _c('form', {
    staticClass: "login-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "username login-input",
    class: {
      active: _vm.usernameErrorShow
    },
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "password login-input",
    class: {
      active: _vm.passwordErrorShow
    },
    attrs: {
      "type": "password",
      "Placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.verificationShow),
      expression: "verificationShow"
    }],
    staticClass: "verification"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imageCode),
      expression: "imageCode"
    }],
    ref: "code",
    staticClass: "verification login-input",
    class: {
      active: _vm.verificationErrorShow
    },
    attrs: {
      "type": "text",
      "Placeholder": "Verification code",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.imageCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imageCode = $event.target.value
      }
    }
  }), _c('img', {
    staticClass: "verification-img",
    attrs: {
      "src": _vm.verifycodeSrc
    },
    on: {
      "click": _vm.getVerifyCode
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.signErrorShow),
      expression: "signErrorShow"
    }],
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.signErrorMsg))]), _c('button', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sign($event)
      }
    }
  }, [_vm._v("Sign In")]), _vm._m(0)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expired),
      expression: "expired"
    }],
    staticClass: "expired-container"
  }, [_c('div', {
    staticClass: "alert-area"
  }, [_c('div', {
    staticClass: "close-btn"
  }), _c('img', {
    staticClass: "oops",
    attrs: {
      "src": require("./oops.png")
    }
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("Your contract has " + _vm._s(_vm.status) + ", so you are unable to login.")]), _vm._m(1), _c('div', {
    staticClass: "ok-btn",
    on: {
      "click": _vm.closeExpiredDialog
    }
  }, [_vm._v("OK")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-tip"
  }, [_vm._v("If you need help, please contact us via email: "), _c('a', {
    attrs: {
      "href": "mailto:affiliate@vipkid-intl.com"
    }
  }, [_vm._v("affiliate@vipkid-intl.com")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-tips"
  }, [_vm._v("If you believe this is an error or if you would like to renew your contract, please contact "), _c('a', {
    attrs: {
      "href": "mailto:affiliate@vipkid-intl.com"
    }
  }, [_vm._v("affiliate@vipkid-intl.com.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a52d955c!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/login.vue
// module id = 300
// module chunks = 2